import {getSubset} from '~/src/utilities/feed/sitemap';
import {SiteArea} from '~/src/utilities/constants/navigation';

/**
 * Video related helpers
 */

/**
 * Get the first video subcategory (AKA the video front)
 */
const getVideoFront = (sitemap) => getSubset(sitemap, SiteArea.VIDEO)[0];

export {getVideoFront};
